import { ReactNode } from "react";
import { View } from "react-native";
import { Text } from "@shared/components/text";
import { colorPalette } from "@shared/config/colorsConfig";
import { HOME_READING, READING_TONE_STYLES, TReadingTone } from "../../../constants";
import { ActivityIconBox } from "./ActivityIconBox";

export type { TReadingTone };

interface IActivityReadingRowProps {
    activityType: string;
    activityName: string;
    title: string;
    timeText?: string;
    tone: TReadingTone;
    value?: string;
    trailing?: ReactNode;
}

export const ActivityReadingRow = ({
    activityType,
    activityName,
    title,
    timeText,
    tone,
    value,
    trailing,
}: IActivityReadingRowProps) => {
    const toneStyle = READING_TONE_STYLES[tone];

    return (
        <View className="flex-row items-center gap-[15px] px-5" style={{ paddingVertical: HOME_READING.rowPaddingY }}>
            <ActivityIconBox
                activityType={activityType}
                activityName={activityName}
                size={HOME_READING.iconBox}
                glyphSize={HOME_READING.iconGlyph}
                color={toneStyle.iconColor}
                backgroundColor={toneStyle.iconBg}
                borderRadius={HOME_READING.iconRadius}
                borderColor={toneStyle.dashedIcon ? colorPalette.gray[300] : undefined}
                borderStyle={toneStyle.dashedIcon ? 'dashed' : 'solid'}
                iconOverride={toneStyle.iconOverride}
            />

            <View className="flex-1">
                <Text className={`font-semibold text-base ${toneStyle.title}`} numberOfLines={2}>{title}</Text>
                {!!timeText && (
                    <Text className={`text-md mt-[3px] ${toneStyle.time}`}>{timeText}</Text>
                )}
            </View>

            {!!value && (
                <Text className="font-heading text-lg text-black text-right shrink-0">{value}</Text>
            )}
            {trailing}
        </View>
    );
};

export default ActivityReadingRow;
